"use client";

import * as React from "react";
import { ComponentPropsWithoutRef } from "react";
import { Tooltip as TooltipBase } from "@base-ui/react/tooltip";
import { cn } from "@/lib/utils";

export function TooltipProvider({ delay = 0, ...props }: TooltipBase.Provider.Props) {
  return <TooltipBase.Provider data-slot="tooltip-provider" delay={delay} {...props} />;
}

export function Tooltip({
  title,
  sideOffset = 8,
  className,
  children,
  ...props
}: ComponentPropsWithoutRef<typeof TooltipBase.Positioner>) {
  return (
    <TooltipBase.Root data-slot="tooltip" disableHoverablePopup={true}>
      <TooltipBase.Trigger data-slot="tooltip-trigger" render={children as React.ReactElement} />
      <TooltipBase.Portal>
        <TooltipBase.Positioner
          data-slot="tooltip-positioner"
          sideOffset={sideOffset}
          className={cn("z-50", className)}
          {...props}
        >
          <TooltipBase.Popup
            data-slot="tooltip-content"
            className="bg-primary text-primary-foreground animate-in fade-in-0 zoom-in-95 data-[closed]:animate-out data-[closed]:fade-out-0 data-[closed]:zoom-out-95 data-[side=bottom]:slide-in-from-top-2 data-[side=left]:slide-in-from-right-2 data-[side=right]:slide-in-from-left-2 data-[side=top]:slide-in-from-bottom-2 z-50 w-fit origin-(--radix-tooltip-content-transform-origin) rounded-md px-3 py-1.5 text-xs text-balance"
          >
            {title}
            <TooltipBase.Arrow
              data-slot="tooltip-arrow"
              className={cn(
                "bg-primary fill-primary z-50 size-2.5 rotate-45 rounded-[2px]",
                "data-[side=bottom]:-translate-y-1/2 data-[side=bottom]:top-px",
                "data-[side=top]:translate-y-1/2 data-[side=top]:bottom-px",
                "data-[side=left]:translate-x-1/2 data-[side=left]:right-px",
                "data-[side=right]:-translate-x-1/2 data-[side=right]:left-px"
              )}
            />
          </TooltipBase.Popup>
        </TooltipBase.Positioner>
      </TooltipBase.Portal>
    </TooltipBase.Root>
  );
}
